<script lang="ts">
  import {onDestroy} from 'svelte';
  import {fly} from 'svelte/transition';
  import {project} from '../../store';
  let active: string = '';
  let template: any | null = null;
  let show: boolean = false;
  let showBtn: boolean = false;
  let box: HTMLElement;
  function changeOverlay(overlay: string) {
    removeOverlay();
    if (overlay == active) {
      active = '';
      return false;
    }
    createOverlay();
    let dom = document.querySelector<HTMLDivElement>('#safeZoneOverlay');
    if (dom) dom.className = overlay;
    active = overlay;
  }

  function removeOverlay() {
    const overlay = document.querySelector('#safeZoneOverlay');
    overlay?.remove();
  }

  function createOverlay() {
    const overlay = document.createElement('div');
    const finalImage = document.querySelector('#finalImageToExport');
    const rects = finalImage?.getBoundingClientRect();
    if (!rects || !finalImage) return;
    overlay.id = 'safeZoneOverlay';
    Object.assign(overlay.style, {
      width: rects.width + 'px',
      height: rects.height + 'px',
      backgroundSize: 'cover',
      position: 'absolute',
      top: rects.top + 'px',
      left: rects.left + 'px',
      zIndex: '1000000',
      pointerEvents: 'none',
      opacity: '0.75'
    });
    document.body.appendChild(overlay);
  }

  function overlayExists() {
    return document.body.querySelector('#safeZoneOverlay');
  }

  onDestroy(() => {
    document.querySelector('#safeZoneOverlay')?.remove();
  });

  function activeClass(overlay: string) {
    return overlay === active ? 'bg-gray-200' : active;
  }

  function hide(ev: MouseEvent) {
    setTimeout(() => {
      const target = ev.target;
      if (target && box.contains(target as HTMLElement)) return;
      show = false;
      // removeOverlay();
    }, 5);
  }

  function determineIfShouldShow(template: any) {
    const dummyDom = document.createElement('div');
    dummyDom.style.visibility = 'hidden';
    dummyDom.style.position = 'absolute';
    dummyDom.innerHTML = template.content;
    document.body.appendChild(dummyDom);
    const rects = dummyDom.getBoundingClientRect();
    if (rects.height > rects.width) {
      //  show = true;
      // TODO: clean up the code to be able to attach on complete listeners to when the editor view is active
      // The reason we are currently doing this is to give the browser time to process the new sizing of the container.
      // This is bad practice and we will need to do something like attach to editor.onStateChangeComplete
      // setTimeout(() => changeOverlay('fb'), 500);
      showBtn = true;
    } else {
      removeOverlay();
      show = false;
      showBtn = false;
    }
    dummyDom.remove();
  }
  const unsubscribe = project.subscribe(project => {
    template = project.template;
    if (template) determineIfShouldShow(template as any);
    else show = false;
  });

  onDestroy(() => {
    unsubscribe();
    // unsubscribeEditor();
  });

  function toggle() {
    show = !show;
    // if(!show) {
    //   removeOverlay();
    //   active = '';
    // }
  }
</script>

<svelte:window on:click={hide} />
{#if showBtn}
  <div bind:this={box} class="relative">
    <div
      class="flex h-11 cursor-pointer items-center rounded-lg border-2 border-neutral-600 bg-white px-4 py-1 font-bold text-gray-800"
      on:click={toggle}
    >
      <span class="inline-block">Preview On</span> <i class="fa fa-caret-down ml-2 inline-block" />
    </div>
    {#if show}
      <div
        in:fly
        id="safeZoneButtons"
        class="absolute right-0 z-50 flex flex-col overflow-hidden rounded-xl border-2 border-neutral-600 bg-white shadow-md"
      >
        <div class="block border-b border-neutral-600 bg-gray-100 p-2 text-center text-xs">
          See what it will look like on the following platforms
        </div>
        <div on:click={() => changeOverlay('fb')} class="hoverbtn" class:selectedbtn={active === 'fb'}>
          <i class="fa fa-facebook" /> <span>Reels</span>
        </div>
        <div on:click={() => changeOverlay('ig')} class="hoverbtn" class:selectedbtn={active === 'ig'}>
          <i class="fa fa-instagram" /> <span>Reels</span>
        </div>
        <div on:click={() => changeOverlay('yt')} class="hoverbtn" class:selectedbtn={active === 'yt'}>
          <i class="fa fa-youtube" /> <span>Shorts</span>
        </div>
        <div on:click={() => changeOverlay('tt')} class="hoverbtn" class:selectedbtn={active === 'tt'}>
          <i class="fa-brands fa-tiktok" /> <span>TikTok</span>
        </div>
      </div>
    {/if}
  </div>
{/if}

<style global lang="postcss">
  .fb {
    background-image: url(https://storage.googleapis.com/sermonshots-local-storage/public/fb.png);
  }

  .ig {
    background-image: url(https://storage.googleapis.com/sermonshots-local-storage/public/ig.png);
  }

  .tt {
    background-image: url(https://storage.googleapis.com/sermonshots-local-storage/public/tt.png);
  }

  .yt {
    background-image: url(https://storage.googleapis.com/sermonshots-local-storage/public/yt.png);
  }

  .hoverbtn {
    @apply flex cursor-pointer items-center border-b border-neutral-600 px-5 py-4 hover:bg-neutral;
  }

  .hoverbtn i {
    @apply w-5 text-left text-xl;
  }
  .hoverbtn span {
    @apply ml-2 font-extrabold;
  }
  .hoverbtn.selectedbtn {
    @apply bg-neutral-600;
  }

  #safeZoneButtons {
    /* bottom: -2px; */
  }
</style>
